import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledSwitchClientForm = styled(Box)`
  display: flex;
  flex-direction: column;

  .SwitchClientForm {
    &-clients {
      display: flex;
      flex-direction: column;
      row-gap: ${props => props.theme.layout('2sp')};
      padding: 0;
      
      .ListItem {
        padding: 0;
      }
      
      .ListItemButton {
        height: ${props => props.theme.layout(68)};
        background-color: ${props => props.theme.property('palette.background.default')};

        .ListItemText {
          > * {
            white-space: normal;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledSwitchClientForm.propTypes = {
  theme: PropTypes.object
};

export default StyledSwitchClientForm;
